module.exports = __webpack_public_path__ + "static/media/proceed.a2f2c59f.svg";